import { render, staticRenderFns } from "./ti12.vue?vue&type=template&id=ef5ef5f6&scoped=true&"
import script from "./ti12.vue?vue&type=script&lang=js&"
export * from "./ti12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5ef5f6",
  null
  
)

export default component.exports